/**
 * An empty object.
 */

export const EmptyObject: Readonly<Record<string, unknown>> = {};
